import axios from 'axios';
import authHeader from '../../../app/axios/header';

export const getUserWords = async (id: string, filter: string, wordsPerPage = '20') => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}users/${id}/aggregatedWords`, {
      params: { wordsPerPage, filter },
      headers: authHeader(),
    })
    .then((response) => {
      return response.data[0].paginatedResults;
    });
};
